import { UserUpdateData } from "@/types/user";

export async function getOrganizations(organizationIds: string[]) {
  const response = await fetch("/api/organizations", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ids: organizationIds }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "Failed to fetch organizations.");
  }

  const { organizations } = await response.json();
  return organizations || [];
}

export async function updateUser(userData: UserUpdateData) {
  const response = await fetch("/api/user", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userData),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "Failed to update user data.");
  }

  const data = await response.json();
  return data.user || null;
}
